<template>
  <b-form-group
    label="Başlık"
    :label-for="iKey + '_title'"
  >
    <b-form-input
      :id="iKey + '_title'"
      v-model="dataItem[iKey].title"
      placeholder="Başlık"
    />

  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'ProductItemsTitleCard',
  components: {
    BFormGroup,
    BFormInput,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['productItems/dataList']
    },
  },
}
</script>
